import React from 'react';
import { useChangeQuantity, useQuantityByPageId, useRemovePage, useToggleOrientation, useUpdatePageId } from 'hooks';
import { usePageConfigContext } from 'context/pageConfig';
import { faMinusCircle, faPen, faPlusCircle, faRedoAlt, faTrash } from '@fortawesome/pro-regular-svg-icons';
import IconButton from 'components/common/IconButton/IconButton';
import c from '../AllPages.module.scss';

const PhotoActions = () => {
  const toggleOrientation = useToggleOrientation();
  const pageConfig = usePageConfigContext();
  const removePage = useRemovePage();
  const quantity = useQuantityByPageId();
  const updatePageId = useUpdatePageId();
  const changeQuantity = useChangeQuantity();
  return (
    <div className={c.photoActionsContainer}>
      <div className={c.photoActions}>
        <IconButton icon={faMinusCircle} onClick={() => changeQuantity(-1)} />
        <div className="quantity">x{quantity}</div>
        <IconButton icon={faPlusCircle} onClick={() => changeQuantity(1)} />
      </div>
      <div className={c.photoActions}>
        <IconButton onClick={toggleOrientation} icon={faRedoAlt} />
        <IconButton icon={faPen} onClick={() => updatePageId(pageConfig?.pageId)} />
        <IconButton onClick={removePage} icon={faTrash} />
      </div>
    </div>
  );
};

export default PhotoActions;
